import { Component, OnDestroy } from '@angular/core';
import { Platform, ToastController, MenuController, AlertController, ActionSheetController, App, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { provider } from '../providers/provider';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { FCM } from '@ionic-native/fcm';
import { LocalNotifications, ILocalNotification } from '@ionic-native/local-notifications';
import { CustomizerProvider } from '../providers/customizer/customizer';
import { AppVersion } from '@ionic-native/app-version';
import { Globalization } from '@ionic-native/globalization';
import { Subject } from 'rxjs';
import { CustomerRegistrationPage } from '../pages/account/customerRegistration/customerRegistration';
import { CustomerEditPage } from '../pages/account/customerEdit/customerEdit';
import { AddressesPage } from '../pages/account/addresses/addresses';
import { CustomerCardPage } from '../pages/account/customercard/customercard';
import { CustomerPage } from '../pages/account/customer/customer';
import { AboutPage } from '../pages/about/about';
import { Search } from '../pages/search/search';
import { MenuPage } from '../pages/menu/menu';
import { HomePage } from '../pages/home/home';

@Component({
  templateUrl: 'app.html'
})
export class smarTavolinux implements OnDestroy {
  private notificationCount = 1;
  rootPage = HomePage;
  version: String;
  private _onDestroy = new Subject();
  customerInfo = {};

  constructor(
    public provider: provider,
    public platform: Platform,
    public toastCtrl: ToastController,
    public statusBar: StatusBar,
    public translateService: TranslateService,
    public splashScreen: SplashScreen,
    public alertCtrl: AlertController,
    public storage: Storage,
    public localNotifications: LocalNotifications,
    public customizer: CustomizerProvider,
    public appVersion: AppVersion,
    private globalization: Globalization,
    public fcm: FCM,
    public actionSheetCtrl: ActionSheetController,
    public menuCtrl: MenuController,
    public app: App,
    public loadingCtrl: LoadingController
  ) {
    storage.set('versione', platform.versions());
    this.getCustomer();
    translateService.setDefaultLang(customizer.getDefaultLanguage());
    translateService.use(customizer.getDefaultLanguage());

    platform.ready().then(() => {
      splashScreen.show();

      this.globalization.getPreferredLanguage().then(res => {
        let value = res.value;
        console.log("Language: " + value)
        let lang = ['it', 'en', 'fr', 'es', 'de'];

        lang.filter((item) => {
          if ((value).toLowerCase().startsWith(item)) {
            translateService.setDefaultLang(item);
            translateService.use(item);
          }
        })
      }).catch(e => {
        translateService.setDefaultLang(customizer.getDefaultLanguage());
        translateService.use(customizer.getDefaultLanguage());
      });

      // blocco tasto indietro
      //platform.registerBackButtonAction(() => console.log('non puoi tornare indietro'));

      this.appVersion.getVersionNumber().then(version => {
        this.version = version;
      }).catch(error => {
        this.version = 'browser';
      });

      this.appVersion.getPackageName().then(packageName => {
        console.log('Package name: ' + packageName);
      }).catch(error => {
        console.log(error)
      });

      statusBar.styleDefault();
      splashScreen.hide();

      // initialize FCM
      this.fcm.getToken().then(token => {
        console.log('Got token: ' + JSON.stringify(token));
        this.updateFCMID(token);
      }, err => console.log('getToken', err));

      this.fcm.onTokenRefresh().subscribe(token => {
        console.log('Token updated.');
        this.updateFCMID(token);
      }, err => console.log('onTokenRefresh', err));

      this.fcm.onNotification().subscribe(data => {
        if (data.wasTapped) {
          console.log("Received in background");
          // post notification
          // this.showLocalNotification(this.buildLocalNotification(data));
        } else {
          console.log("Received in foreground");
          // show notification popup
          // this.showNotificationPopup(this.buildLocalNotification(data));
        };
        // show notification
        this.showLocalNotification(this.buildLocalNotification(data));
      }, err => console.log('onNotification', err));
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  getCustomer() {
    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });
  }

  openMenu() {
    this.getCustomer();
    this.menuCtrl.open();
  }

  closeMenu() {
    this.getCustomer();
    this.menuCtrl.close();
  }

  toggleMenu() {
    this.menuCtrl.toggle();
  }

  GOTOhomepage() {
    // if cart is not empty, ask user
    const cart = this.provider.getCart();
    if (cart.length > 0) {
      this.translateService.get(['ATTENZIONE', 'CART_IS_NOT_EMPTY', 'PROCEED', 'ANNULLA']).takeUntil(this._onDestroy).subscribe(msg => {
        const prompt = this.alertCtrl.create({
          title: msg.ATTENZIONE,
          message: msg.CART_IS_NOT_EMPTY,
          buttons: [
            { text: msg.ANNULLA },
            {
              text: msg.PROCEED,
              handler: result => {
                this.provider.setSelectedLocale(false);
                this.provider.clearApp();
                location.reload();
                this.app.getActiveNav().push(HomePage);
              }
            }
          ]
        });
        prompt.present();
      });
    } else {
      // go back to home
      this.provider.setSelectedLocale(false);
      this.provider.clearApp();
      location.reload();    
      this.app.getActiveNav().push(HomePage);
    }
  }

  GOTOedit() {
    //this.provider.deleteCart();
    this.app.getActiveNav().push(CustomerEditPage);
  }

  GOTOregistration() {
    this.app.getActiveNav().push(CustomerRegistrationPage);
  }

  GOTOlogin() {
    this.app.getActiveNav().push(CustomerPage);
  }

  GOTOaddresses() {
    this.app.getActiveNav().push(AddressesPage);
  }

  GOTOcards() {
    this.app.getActiveNav().push(CustomerCardPage);
  }

  GOTOinfoLocale() {
    this.app.getActiveNav().push(AboutPage);
  }

  search() {
    this.app.getActiveNav().push(Search);
  }

  logout() {
    //this.storage.remove('customer');
    this.storage.clear();
    this.provider.deleteCart();
    this.getCustomer();
    this.app.getActiveNav().push(MenuPage);
  }

  translate() {
    let lang = ['it', 'en', 'fr', 'es', 'de'];

    this.translateService.get('LANGUAGE').takeUntil(this._onDestroy).subscribe(obj => {
      let buttons = obj.languages.map((language, index) => ({
        text: language, handler: () => { this.storage.set('language', lang[index]); this.translateService.use(lang[index]); }
      }))
      let actionSheet = this.actionSheetCtrl.create({
        title: obj.label,
        buttons
      });
      actionSheet.present();
    });
  };

  //! buildLocalNotification created a local notification object to be used in many context
  buildLocalNotification(notification): ILocalNotification {
    var notificationId = this.notificationCount++;
    var notificationObj: ILocalNotification = {
      id: notificationId,
      badge: notificationId, // brutta, lo
      title: 'TAP Menu',
      text: '',
      led: '',
      sound: null,
      foreground: true,
    };
    if (notification.action === 'RESCHEDULED') {
      var date = new Date(notification.args);
      notificationObj.text = 'Ciao, c\'è molto lavoro e l\'esercente ha dovuto spostare il tuo ordine alle ' + date.getHours()+':'+date.getMinutes() + '.'; //.toLocaleTimeString('it-IT')
      notificationObj.led = '00ff6501'; // orange
    } else if (notification.action === 'VOIDED') {
      notificationObj.text = 'Siamo spiacenti, ma il tuo ordine è stato annullato. Contatta l\'esercente per chiarimenti.';
      notificationObj.led = '00ff0000'; // red
    } else if (notification.action === 'CONFIRMED') {
      notificationObj.text = 'Perfetto ! Il tuo ordine è stato gestito dall\'esercente. A breve !'
      notificationObj.led = '0000ff00'; // green
    }
    return notificationObj;
  }

  //! showLocalNotification shows the local notification popup
  showLocalNotification(notification: ILocalNotification) {
    this.localNotifications.schedule(notification);
  }

  //! showLocalNotification schedules a mobile notification message with led
  showNotificationPopup(notification: ILocalNotification) {
    let message = '';
    if (Array.isArray(notification.text)) {
      message = notification.text[0];
    } else {
      message = notification.text;
    }
    const alert = this.alertCtrl.create({
      title: notification.title,
      message: message,
      buttons: [
        { text: 'OK', role: 'cancel' }
      ]
    });
    alert.present();
  }

  showInvalidUserPopup() {
    console.log('Invalid user in local storage !');
    this.storage.remove('customer').then(() => {
      const alert = this.alertCtrl.create({
        title: 'Utente cancellato',
        message: 'L\'utente corrente è stato cancellato dal database centrale.',
        buttons: [
          { text: 'OK', role: 'cancel' }
        ]
      });
      alert.present();
    });
  }

  // update fcmID for user
  updateFCMID(token) {
    console.log('Token updated.');
    this.storage.set('fcmID', token).then(() => {
      this.storage.get('customer').then((customerJSON) => {
        if (customerJSON == null) {
          console.log('Customer not yet logged in.');
        } else {
          // customer information decode
          var customerInfo = JSON.parse(customerJSON);
          // check for takeAwayToken
          if (this.customizer.takeAwayToken() != null)
            this.provider.setTable(this.customizer.takeAwayToken());
          // proceed with user
          this.provider.getCustomer(customerInfo._id).subscribe((updatedCustomer) => {
            var body = (<any>updatedCustomer)._body;
            if (body.length > 0) {
              // got user from server
              customerInfo = JSON.parse((<any>updatedCustomer)._body);
              this.provider.updateFCMID(customerInfo._id, token).then(() => {
                console.log('User updated on server');
                // update fcmID con local customer
                customerInfo.fcmID = token;
                this.storage.set('customer', JSON.stringify(customerInfo)).then(() => {
                  console.log('User updated on local storage')
                });
              },
                (err) => {
                  console.log('User update error: ' + err);
                })
              console.log('Customer logged in. Set fcmID to ' + token + ' for customer ' + customerInfo._id);

            } else {
              console.log('No body from server');
              this.showInvalidUserPopup();
            }
          },
          (err) => {
                console.log('Error fetching server body');
                this.showInvalidUserPopup();
          });


        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts